import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface BaseInfoReq {
  /** 设备id */
  device_id: string
}

export interface Accounts {
  /** 用户名 */
  name: string
  /** 状态 1：启用 2：禁用 */
  status?: number
}

export interface BaseInfoRes {
  /** 分组名 */
  group_name: string
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 产品id */
  product_id: string
  /** 内网ip */
  system_ip: string
  /** 外网IP */
  client_ip: string
  /** 终端id（唯一标识） */
  device_id: string
  /** 操作系统类型，1-Windows,2-linux */
  system_type: number
  /** 系统名 */
  system_name: string
  /** 账户信息 */
  accounts?: Accounts[]
  /** 本次开机时间 */
  current_startup_time?: number
  /** 防御功能 1：正常 2：正常 */
  defense?: number
  /** 上次离线时间 */
  last_offline_time?: number
  /** 登录状态 */
  login_status?: number
  /** 防护策略 */
  strategy_name?: string
  /** 今日在线时长 */
  today_online_time?: number
  /** 终端版本 */
  version: string
  /** 进行中任务数 */
  task_count: number
}

@Injectable()
export class TerminalInfoService {
  constructor (private http: Http) {
  }

  getBaseInfo (data: BaseInfoReq) {
    return this.http.post<BaseInfoRes>('/terminal/hardware/base_info', data)
  }
}
